import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, vShow as _vShow, withDirectives as _withDirectives, withModifiers as _withModifiers, resolveDirective as _resolveDirective, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-76e32f7f"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "relative h-12 bg-white rounded-md" }
const _hoisted_2 = { class: "flex pt-3 pb-4 pl-4 pr-2 space-x-4" }
const _hoisted_3 = { class: "flex-1 my-auto text-left opacity-80" }
const _hoisted_4 = { class: "my-auto" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("title", null, "ic_down", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("g", {
  id: "Page-1",
  stroke: "none",
  "stroke-width": "1",
  fill: "none",
  "fill-rule": "evenodd"
}, [
  /*#__PURE__*/_createElementVNode("g", {
    id: "down",
    transform: "translate(-371.000000, -159.000000)",
    fill: "#2D2D2E",
    "fill-rule": "nonzero"
  }, [
    /*#__PURE__*/_createElementVNode("g", {
      id: "Group-7",
      transform: "translate(290.000000, 136.000000)"
    }, [
      /*#__PURE__*/_createElementVNode("path", {
        id: "ic_down",
        d: "M89.4623082,23.4771353 C89.7510783,23.1801763 90.2259057,23.173538 90.5228647,23.4623082 C90.7928274,23.7248265 90.8228557,24.1411111 90.609127,24.4377393 L90.5376918,24.5228647 L86.7265327,28.4420986 C86.535908,28.6384267 86.274262,28.7499995 86,28.7499995 C85.7649183,28.7499995 85.5391055,28.6680278 85.3595912,28.5212289 L85.2738637,28.4425066 L81.4623082,24.5228647 C81.173538,24.2259057 81.1801763,23.7510783 81.4771353,23.4623082 C81.747098,23.1997898 82.1640594,23.1814107 82.4545968,23.4033484 L82.5376918,23.4771353 L85.999,27.037 L89.4623082,23.4771353 Z"
      })
    ])
  ])
], -1))
const _hoisted_7 = [
  _hoisted_5,
  _hoisted_6
]
const _hoisted_8 = ["onClick"]
const _hoisted_9 = { class: "flex-1 my-auto" }
const _hoisted_10 = { class: "my-auto" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  width: "17px",
  height: "12px",
  viewBox: "0 0 17 12",
  version: "1.1",
  xmlns: "http://www.w3.org/2000/svg",
  "xmlns:xlink": "http://www.w3.org/1999/xlink"
}, [
  /*#__PURE__*/_createElementVNode("title", null, "ic_selected"),
  /*#__PURE__*/_createElementVNode("g", {
    id: "Page-1",
    stroke: "none",
    "stroke-width": "1",
    fill: "none",
    "fill-rule": "evenodd"
  }, [
    /*#__PURE__*/_createElementVNode("g", {
      id: "selected",
      transform: "translate(-1079.000000, -468.000000)",
      fill: "#2D2D2E",
      "fill-rule": "nonzero"
    }, [
      /*#__PURE__*/_createElementVNode("g", {
        id: "Group-7",
        transform: "translate(735.000000, 324.000000)"
      }, [
        /*#__PURE__*/_createElementVNode("g", {
          id: "check-1",
          transform: "translate(345.000000, 145.000000)"
        }, [
          /*#__PURE__*/_createElementVNode("path", {
            id: "ic_selected",
            d: "M14.3192651,-0.7325299 C14.7238302,-1.10848938 15.3565704,-1.08529995 15.7325299,-0.680734857 C16.0795694,-0.307290156 16.0865057,0.260575925 15.767318,0.641432518 L15.6807349,0.7325299 L4.91986529,10.7325299 C4.55605776,11.0706137 4.0055226,11.0870478 3.62374622,10.7883443 L3.53202365,10.7071068 L-0.707106781,6.46797635 C-1.09763107,6.07745205 -1.09763107,5.44428708 -0.707106781,5.05376278 C-0.34662282,4.69327882 0.220608236,4.66554929 0.612899443,4.97057418 L0.707106781,5.05376278 L4.265,8.611 L14.3192651,-0.7325299 Z"
          })
        ])
      ])
    ])
  ])
], -1))
const _hoisted_12 = [
  _hoisted_11
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _directive_click_outside = _resolveDirective("click-outside")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _withDirectives((_openBlock(), _createElementBlock("button", {
      type: "button",
      class: _normalizeClass([_ctx.expandDropdown ? 'border-black z-10' : 'border-gray-400', "select-button w-full h-full absolute border rounded-md relative"]),
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onSelectClicked && _ctx.onSelectClicked(...args)))
    }, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("span", _hoisted_3, _toDisplayString((_ctx.value && _ctx.value[_ctx.itemText]) || _ctx.label), 1),
        _createElementVNode("span", _hoisted_4, [
          (_openBlock(), _createElementBlock("svg", {
            class: _normalizeClass([{ 'transform rotate-180': _ctx.expandDropdown }, "transition-transform my-auto"]),
            width: "10px",
            height: "6px",
            viewBox: "0 0 10 6",
            version: "1.1",
            xmlns: "http://www.w3.org/2000/svg",
            "xmlns:xlink": "http://www.w3.org/1999/xlink"
          }, _hoisted_7, 2))
        ])
      ]),
      _createElementVNode("div", {
        class: _normalizeClass([_ctx.expandDropdown ? 'max-h-120 border' : 'max-h-0', "bg-white transition-max-h rounded-md divide-y overflow-y-auto flex flex-col"])
      }, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.items, (item) => {
          return (_openBlock(), _createElementBlock("button", {
            key: item,
            type: "button",
            class: "p-4 space-x-2 hover:bg-gray-100 font-semibold text-left flex",
            onClick: _withModifiers(($event: any) => (_ctx.onItemClicked(item)), ["stop"])
          }, [
            _createElementVNode("span", _hoisted_9, _toDisplayString(item[_ctx.itemText]), 1),
            _withDirectives(_createElementVNode("span", _hoisted_10, _hoisted_12, 512), [
              [_vShow, _ctx.value && _ctx.value[_ctx.itemValue] === item[_ctx.itemValue]]
            ])
          ], 8, _hoisted_8))
        }), 128))
      ], 2)
    ], 2)), [
      [_directive_click_outside, () => (_ctx.expandDropdown = false)]
    ])
  ]))
}